type NoAccessPageProps = {
  email?: string;
  onLogout: () => void;
};

/** Shown when Auth0 signed someone in who was never invited (or was disabled). */
function NoAccessPage({ email, onLogout }: NoAccessPageProps) {
  return (
    <main className="page loadingPage">
      <h1>No access</h1>
      {email ? <p className="userEmail">{email}</p> : null}
      <p role="alert">
        Access is by invitation only. Ask an administrator to invite you.
      </p>
      <button className="primaryButton" onClick={onLogout}>
        Log out
      </button>
    </main>
  );
}

export default NoAccessPage;
